export const header = {
  en: {
    'Email templates': 'Email templates',
    Menu: 'Menu',
    Reception: 'Reception',
    Catalog: 'Catalog',
    Warehouse: 'Warehouse',
    Cash: 'Cash',
    'Cash desk': 'Cash',
    'Cash for today': 'Cash for today',
    Integrations: 'Integrations',
    Settings: 'Settings',
    Staff: 'Staff',
    Reports: 'Reports',
    'Stock & inventory': 'Stock & inventory',
    Warehouses: 'Warehouses',
    'Warehouses (prototype)': 'Warehouses (prototype)',
    'Product Categories': 'Product folders',
    Products: 'Products',
    Suppliers: 'Suppliers',
    'Suppliers (prototype)': 'Suppliers (prototype)',
    Waybills: 'Waybills',
    'System settings': 'System settings',
    'Clients, bookings & sales': 'Clients, bookings & sales',
    'Stock & supplies': 'Stock & supplies',
    'Staff & user logs': 'Staff & user logs',
    'Owners & companies': 'Owners & companies',
    Documentation: 'Documentation',
    Clients: 'Clients',
    Certificates: 'Certificates',
    Services: 'Services',
    'Catalog services': 'Services',
    Cards: 'Cards',
    'Service Categories': 'Service categories',
    'General Statistics': 'General statistics',
    'Income Statistics': 'Income statistics',
    Payments: 'Payments',
    'Orders Info': 'Orders Info',
    'User Logs': 'User logs',
    'Audit Log': 'Audit log',
    Users: 'Users',
    Trainers: 'Trainers',
    'Service Usage History': 'Service usage history',
    Companies: 'Companies',
    'Log Out': 'Log out',
    'Returned Clients': 'Returned clients',
    'New Clients': 'New clients',
    'Month Income': 'Month income statistics',
    'Subscriptions Statistics': 'Subscriptions statistics',
    'Online Services': 'Online services',
    Locations: 'Locations',
    Cashiers: 'Cashiers',
    'CSV Files': 'CSV Files',
    'Services Rating': 'Services Rating',
    'Average Service Visits': 'Average Service Visits',
    'Active Purchased Services By Service':
      'Active Purchased Services By Service',
    'Expiring Purchased Services': 'Expiring Purchased Services',
    Booking: 'Booking',
    Reservations: 'Reservations',
    'Booking Reservations': 'Reservations',
    'Recurring classes': 'Recurring classes',
    'Booking Recurring classes': 'Recurring classes',
    'Company events': 'Company events',
    'Booking Company events': 'Company events',
    'Bookings By Payment Dates': 'Bookings By Payment Dates',
    'Bookings By Booking Dates': 'Bookings By Booking Dates',
    'Booking Services': 'Booking Services',
    'Booking Providers': 'Booking Providers',
    'Provider Work Time': 'Provider Work Time',
    'Recurring Events': 'Recurring Events',
    Calendar: 'Calendar',
    'Booking Calendar': 'Calendar',
    'All Bookings': 'All Bookings',
    'Coming soon': 'Coming soon ...',
    'Daily cash operations': 'Daily cash operations',
    'Operations journal': 'Operations journal',
    'Booking Settings': 'Booking Settings',
    'Email Templates': 'Email Templates',
    'Income Payment Settings': 'Income payment settings',
    'Payment Cards': 'Payment Cards',
    'Online Payment Keys': 'Online Payment Keys',
    'PayBridge Tokens': 'PayBridge Tokens',
    'Cashier Terminals': 'Cashier Terminals',
    Terminals: 'Terminals',
    PayBridge: 'PayBridge',
    'POS terminals': 'POS terminals',
    'Payment terminals': 'Payment terminals',
    Acquiring: 'Acquiring',
    LiqPay: 'LiqPay',
    MonoPay: 'MonoPay',
    'Legal Entities': 'Legal Entities',
    'Business Directions': 'Business Directions',
    'Cash Registers': 'Cash Registers',
    Ledger: 'Ledger',
    'Transaction Categories': 'Transaction Categories',
    'Revenue Categories': 'Revenue Categories',
    'Expense Categories': 'Expense Categories',
    'Discount Reasons': 'Discount Reasons',
    'Refund Reasons': 'Refund Reasons',
    'Operations Journal': 'Operations Journal',
    'Cash Flow': 'Cash Flow',
    'Profit & Loss': 'Profit & Loss',
    'Recognition Runs': 'Recognition Runs',
    'Certificate Reports': 'Certificate Reports',
    'Product Reports': 'Product Reports',
    'Stock balances': 'Stock balances',
    'Product sales': 'Product sales',
    'Movement of a product': 'Movement of a product',
    'Goods movement': 'Goods movement',
    'Transfers between warehouses': 'Transfers between warehouses',
    'Stock-count history': 'Stock-count history',
    'Supply and payment history': 'Supply and payment history',
    'Settlements with a supplier': 'Settlements with a supplier',
    Revenue: 'Revenue',
    Expense: 'Expense',
    'Catalog & company configuration': 'Catalog & company configuration',
    'Custom Fields': 'Custom Fields',
    'Staff Passes': 'Staff Passes',
    Salary: 'Salary',
    'Scanning Devices': 'Scanning Devices',
    'Interface version': 'Interface version',
    'Switch to V2? The interface will reload.':
      'Switch to V2? The interface will reload.',
    'Switch to V1? The interface will reload.':
      'Switch to V1? The interface will reload.',
    Switch: 'Switch',
    Fiscalization: 'Fiscalization',
    'Cash register shifts': 'Cash register shifts',
    'Specialist Payouts (temporary)': 'Specialist Payouts (temporary)',
  },
  uk: {
    Menu: 'Меню',
    Reception: 'Ресепшн',
    Catalog: 'Каталог',
    Warehouse: 'Склад',
    Cash: 'Каса',
    'Cash desk': 'Каса',
    'Cash for today': 'Каса за сьогодні',
    Integrations: 'Інтеграції',
    Settings: 'Налаштування',
    Staff: 'Працівники',
    Reports: 'Звіти',
    'Stock & inventory': 'Склад та запаси',
    Warehouses: 'Склади',
    'Warehouses (prototype)': 'Склади (прототип)',
    'Product Categories': 'Папки товарів',
    Products: 'Товари',
    Suppliers: 'Постачальники',
    'Suppliers (prototype)': 'Постачальники (прототип)',
    Waybills: 'Накладні',
    'System settings': 'Системні налаштування',
    'Clients, bookings & sales': 'Клієнти, бронювання та продажі',
    'Stock & supplies': 'Склад та постачання',
    'Staff & user logs': 'Працівники та журнал дій',
    'Owners & companies': 'Власники та компанії',
    Documentation: 'Документація',
    Clients: 'Клієнти',
    Certificates: 'Сертифікати',
    Services: 'Сервіси',
    'Catalog services': 'Послуги',
    Cards: 'Картки',
    'Service Categories': 'Категорії сервісів',
    'General Statistics': 'Загальна статистика',
    'Income Statistics': 'Статистика доходів',
    Payments: 'Платежі',
    'Orders Info': 'Інформація щодо замовлень',
    'User Logs': 'Журнал',
    'Audit Log': 'Журнал дій',
    Users: 'Користувачі',
    Trainers: 'Тренери',
    'Service Usage History': 'Історія використання сервісів',
    Companies: 'Компанії',
    'Log Out': 'Вийти',
    'Returned Clients': 'Клієнти, які повернулися',
    'New Clients': 'Нові клієнти',
    'Month Income': 'Статистика по місячному доходу',
    'Subscriptions Statistics': 'Статистика по підпискам',
    'Online Services': 'Онлайн сервіси',
    Locations: 'Локації',
    Cashiers: 'Касири',
    'CSV Files': 'CSV Файли',
    'Services Rating': 'Рейтинг сервісів',
    'Average Service Visits': 'Середня кількість відвідувань по сервісу',
    'Active Purchased Services By Service':
      'Кількість активних куплених сервісів',
    'Expiring Purchased Services': 'Придбані сервіси, які закінчуються',
    Booking: 'Букінг',
    Reservations: 'Записи',
    'Booking Reservations': 'Записи',
    'Recurring classes': 'Регулярні заняття',
    'Booking Recurring classes': 'Регулярні заняття',
    'Company events': 'Події клубу',
    'Booking Company events': 'Події клубу',
    'Bookings By Payment Dates': 'Сплачені бронювання по датах платежів',
    'Bookings By Booking Dates': 'Сплачені бронювання по датах бронювання',
    'Booking Services': 'Букінг сервіси',
    'Booking Providers': 'Букінг провайдери',
    'Provider Work Time': 'Робочий час провайдера',
    'Recurring Events': 'Повторювані події',
    'Email templates': 'Емейл шаблони',
    Calendar: 'Календар',
    'Booking Calendar': 'Календар',
    'All Bookings': 'Всі бронювання',
    'Coming soon': 'В розробці ...',
    'Daily cash operations': 'Щоденні касові операції',
    'Operations journal': 'Журнал операцій',
    'Booking Settings': 'Налаштування',
    'Email Templates': 'Поштові шаблони',
    'Income Payment Settings': 'Налаштування платежів',
    'Payment Cards': 'Платіжні картки',
    'Online Payment Keys': 'Платіжні ключі',
    'PayBridge Tokens': 'PayBridge токени',
    'Cashier Terminals': 'Касові термінали',
    Terminals: 'Термінали',
    PayBridge: 'PayBridge',
    'POS terminals': 'POS термінали',
    'Payment terminals': 'Платіжні термінали',
    Acquiring: 'Еквайринг',
    LiqPay: 'LiqPay',
    MonoPay: 'MonoPay',
    'Legal Entities': 'Юридичні особи',
    'Business Directions': 'Напрямки діяльності',
    'Cash Registers': 'Каси',
    Ledger: 'Облік',
    'Transaction Categories': 'Категорії транзакцій',
    'Revenue Categories': 'Категорії надходжень',
    'Expense Categories': 'Категорії витрат',
    'Discount Reasons': 'Причини знижки',
    'Refund Reasons': 'Причини повернення',
    'Operations Journal': 'Журнал операцій',
    'Cash Flow': 'Рух грошових коштів',
    'Profit & Loss': 'Прибутки та збитки',
    'Recognition Runs': 'Визнання виручки',
    'Certificate Reports': 'Обіг сертифікатів',
    'Product Reports': 'Звіти по товарах',
    'Stock balances': 'Залишки товарів',
    'Product sales': 'Продаж товарів',
    'Movement of a product': 'Рух по товару',
    'Goods movement': 'Рух товарів',
    'Transfers between warehouses': 'Переміщення між складами',
    'Stock-count history': 'Історія звірок',
    'Supply and payment history': 'Історія поставок і оплат',
    'Settlements with a supplier': 'Розрахунки з постачальником',
    Revenue: 'Доходи',
    Expense: 'Витрати',
    'Catalog & company configuration': 'Каталог та налаштування компанії',
    'Custom Fields': 'Додаткові поля',
    'Staff Passes': 'Перепустки персоналу',
    Salary: 'Зарплата',
    'Scanning Devices': 'Скануючі пристрої',
    'Interface version': 'Версія інтерфейсу',
    'Switch to V2? The interface will reload.':
      'Перемкнути на V2? Інтерфейс перезавантажиться.',
    'Switch to V1? The interface will reload.':
      'Перемкнути на V1? Інтерфейс перезавантажиться.',
    Switch: 'Перемкнути',
    Fiscalization: 'Фіскалізація',
    'Cash register shifts': 'Зміни на касах',
    'Specialist Payouts (temporary)': 'Виплати спеціалістам (тимчасово)',
  },
};
